import { get } from '@/api/fetch'

export function loginSupport(accessToken: string) {
  return get<boolean>(`/users/token/${accessToken}/checkSupport`).then(res => res.data)
}
